import { render } from "./SidebarMenuItemBot5.vue?vue&type=template&id=fa127776&scoped=true"
import script from "./SidebarMenuItemBot5.vue?vue&type=script&lang=js"
export * from "./SidebarMenuItemBot5.vue?vue&type=script&lang=js"

import "./SidebarMenuItemBot5.vue?vue&type=style&index=0&id=fa127776&scoped=true&lang=scss"

import exportComponent from "/home/tachyon/wardrobe-test2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa127776"]])

export default __exports__